import { Link, usePage } from "@inertiajs/react";
import { Button } from "@/components/ui/button";
import { Coins, Plus, Sparkles } from "lucide-react";
import { NavLinks } from "./NavLinks";
import { UserMenu } from "./UserMenu";

interface NavbarProps {
  user?: { email: string } | null;
}

export function Navbar({ user }: NavbarProps) {
  const { url, props } = usePage();
  const currentUser = props.current_user;

  const isActive = (path: string) => url.startsWith(path);

  const paidCredits = currentUser?.paid_credits ?? 0;

  return (
    <nav className="sticky top-0 z-30 border-b border-border bg-background/80 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
        <div className="flex items-center gap-6">
          <Link href="/" className="flex items-center gap-3">
            <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary/20 text-primary">
              <Sparkles size={18} />
            </div>
            <span className="text-lg font-semibold text-foreground">fotoCerta</span>
          </Link>

          <NavLinks isActive={isActive} />
        </div>

        <div className="flex items-center gap-2">
          {currentUser && (
            <Link
              href="/paid_credits"
              className="flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-sm text-muted-foreground transition hover:bg-accent/10 hover:text-foreground"
            >
              <Coins size={15} />
              <span className="font-semibold text-foreground">{paidCredits}</span>
            </Link>
          )}

          <Button asChild size="sm" className="gap-2">
            <Link href="/submissions/new">
              <Plus size={16} />
              <span className="hidden sm:inline">Enviar Foto</span>
              <span className="sm:hidden">Enviar</span>
            </Link>
          </Button>

          {user && <UserMenu isActive={isActive} />}
        </div>
      </div>
    </nav>
  );
}
